// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const LensInsightsHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensInsightsHeader"
        description="Lens insights header."
        defaultMessage="Lens Insights"
    />
);
LensInsightsHeader.displayName = "LensInsightsHeader";

export const LensInsightsLink = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensInsightsLink"
        description="Lens insights link."
        defaultMessage="View Full Insights"
    />
);
LensInsightsLink.displayName = "LensInsightsLink";

export const LensInsightsLinkEngagement = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensInsightsLinkEngagement"
        description="Lens insights link engagement."
        defaultMessage="View Full Engagement"
    />
);
LensInsightsLinkEngagement.displayName = "LensInsightsLinkEngagement";

export const LensInsightsLinkPayout = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensInsightsLinkPayout"
        description="Lens insights link payout."
        defaultMessage="View Full Payout Insights"
    />
);
LensInsightsLinkPayout.displayName = "LensInsightsLinkPayout";

export const LensStatsEngagementSection = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensStatsEngagementSection"
        description="Lens stats engagement section."
        defaultMessage="Engagement & Reach"
    />
);
LensStatsEngagementSection.displayName = "LensStatsEngagementSection";

export const LensStatsMonetizationSection = (): ReactElement => (
    <FormattedMessage
        id="apps.lensStats.components.lensStatsMonetizationSection"
        description="Lens stats monetization section."
        defaultMessage="Payout Drivers"
    />
);
LensStatsMonetizationSection.displayName = "LensStatsMonetizationSection";
